import { render, staticRenderFns } from "./labor-time-guide-page.vue?vue&type=template&id=18730528&scoped=true&"
import script from "./labor-time-guide-page.vue?vue&type=script&lang=js&"
export * from "./labor-time-guide-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18730528",
  null
  
)

export default component.exports